

const LinearGradient=({width="w-full"})=>{
    return <div className={`h-0.5 ${width}bg-gradient-blue`}/>
}

export default LinearGradient